import React, {Component, Fragment} from "react";
import TextInput from "ps-react/TextInput";

class ExampleOptional extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: ""
		}
	}

	handleChange = e => {
		this.setState({[e.target.name] : e.target.value});
	};

	render() {
		return (
			<Fragment>
				<TextInput
					htmlId="example-optional"
					name="firstname"
					label="First name"
					onChange={this.handleChange }
				/>
			</Fragment>
		);
	}
}

export default ExampleOptional;
